import axios from 'axios';

import {
  SNACKBAR_SET,
  GENERAL_REQUEST_LOADED,
  MODAL_FORM_TOGGLE,
  AUTH_USER_TOKEN_EXPIRY,

  LOGOUT,
  GENERAL_REQUEST_LOADING,
} from '../actions/types';

import { getMeta } from './MetaService';

const { REACT_APP_API_URL } = process.env;
const config = { apiUrl: REACT_APP_API_URL };


export function apiRequest(dispatch, navigation, token, endpoint, data, responseDispatches, responseRedirects={success: null, fail: null}, showSnackBar={success: null, fail: null}, responseFunctions={success: null, fail: null}, customData=false, customResponse=false, customHeaders=false, disableLoading=false, addMeta=true){
  if(!responseDispatches) responseDispatches = {success: null, fail: null};
  if(!responseRedirects) responseRedirects = {success: null, fail: null};
  if(!showSnackBar) showSnackBar = {success: null, fail: null};
  if(!responseFunctions) responseFunctions = {success: null, fail: null};
  if(!customHeaders) customHeaders = {};
  if(!disableLoading) dispatch({ type: GENERAL_REQUEST_LOADING });

  let postData = (customData)? data : { data: data };
  
  if (addMeta) postData['meta'] = getMeta();

  axios.post(config.apiUrl+endpoint,
  postData,
  { headers: { ...customHeaders, token: token } })
  .then((response) => {
    if (response.data.code === 0) {
      updateUserTokenExpiration(dispatch, response.data.data.TOKEN_EXPIRY);
      dispatch({ type: MODAL_FORM_TOGGLE })
      apiRequestSuccess(
        dispatch,
        navigation,
        response.data.data,
        response.data.data.message,
        responseDispatches.success,
        responseRedirects.success,
        showSnackBar.success,
        responseFunctions.success,
        customResponse
      );
    } else {
      apiRequestFail(
        dispatch,
        navigation,
        true,
        response.data.data.error,
        responseDispatches.fail,
        responseRedirects.fail,
        showSnackBar.fail || showSnackBar.error,
        responseFunctions.fail
      );
      if(response.data.data.error.FORCE_LOGOUT){
        dispatch({
          type: LOGOUT
        });
      }
    }
  })
  .catch((error) => {
    apiRequestFail(
      dispatch,
      navigation,
      true,
      error,
      responseDispatches.fail,
      responseRedirects.fail,
      showSnackBar.fail || showSnackBar.error,
      responseFunctions.fail
    );
  });
  
};

const apiRequestSuccess = (
  dispatch,
  navigation,
  data,
  message,
  responseDispatch,
  responseRedirect,
  showSnackBar,
  responseFunction,
  customResponse
) => {
  dispatchSuccessTypes(dispatch, responseDispatch, data, customResponse)
  if(showSnackBar === true){
    dispatch({
      type: SNACKBAR_SET,
      message: message,
      severity: 'notificationBarSuccess',
      horizontal: 'center',
      vertical: 'bottom',
    });
  }
  if(responseFunction) responseFunction();
  dispatch({ type: GENERAL_REQUEST_LOADED });
  if(responseRedirect && navigation) navigation.push(responseRedirect);
};

const apiRequestFail = (
  dispatch,
  navigation,
  error,
  errors,
  responseDispatch,
  responseRedirect,
  showSnackBar,
  responseFunction
) => {
  const message = (errors.GENERAL)? errors.GENERAL : errors.message;
  dispatchFailTypes(dispatch, responseDispatch, errors);
  if(showSnackBar === true){
    dispatch({
      type: SNACKBAR_SET,
      message: message,
      severity: 'notificationBarFailed',
      horizontal: 'center',
      vertical: 'bottom',
    });
  }
  if(responseFunction) responseFunction();
  dispatch({ type: GENERAL_REQUEST_LOADED });
  if(responseRedirect && navigation) navigation.push(responseRedirect);
};

export const dispatchSuccessTypes = (dispatch, types, data, customResponse) => {
  if(Array.isArray(types)){
    types.forEach(type => {
      if(!type){
        return false;
      }
      if(customResponse){
        dispatch({
          type: type,
          ...data
        });
      }else{
        dispatch({
          type: type,
          data,
        });
      }
    });
  }else{
    if(!types){
      return false;
    }
    if(customResponse){
      dispatch({
        type: types,
        ...data
      });
    }else{
      dispatch({
        type: types,
        data,
      });
    }
  }
}

export const dispatchFailTypes = (dispatch, types, errors) => {
  if(Array.isArray(types)){
    types.forEach(type => {
      if(!type){
        return false;
      }
      dispatch({
        type: type,
        error: true,
        errors
      });
    });
  }
  else{
    if(!types){
      return false;
    }
    dispatch({
      type: types,
      error: true,
      errors
    });
  }
}

export const validationFail = (dispatch, responseDispatch, errors, showSnackBar) => {
  dispatchFailTypes(dispatch, responseDispatch, errors);
  if(showSnackBar){
    dispatch({
      type: SNACKBAR_SET,
      message: errors.message,
      severity: 'notificationBarFailed',
      horizontal: 'center',
      vertical: 'bottom',
    });
  }
};

export const updateUserTokenExpiration = (dispatch, token_expiry) => {
  if(!token_expiry) return false
  dispatch({
    type: AUTH_USER_TOKEN_EXPIRY,
    expiry: token_expiry
  });
};
